var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9929 25.9963C50.6596 40.3275 39.6612 51.3259 25.9965 50.9926C12.1651 50.6593 1 39.8276 1 25.9963C1 12.165 12.1651 1 25.9965 1C39.8278 1 51.3262 12.165 50.9929 25.9963Z",
    fill: "black",
    stroke: "#A80E3A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4953 17.1643C34.4953 22.9968 30.6625 29.1625 25.9965 29.1625C21.3305 29.1625 17.4977 23.1634 17.4977 17.1643C17.4977 11.1652 21.3305 7.66568 25.9965 7.66568C30.6625 7.66568 34.4953 11.3318 34.4953 17.1643Z",
    fill: "#D89F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4955 30.4956H30.8292C29.996 32.3287 28.1629 33.4952 25.9965 33.4952C23.8302 33.4952 21.9971 32.3287 21.1639 30.4956H18.4976C15.1647 30.4956 12.3318 33.3286 12.3318 36.6614V40.4942C15.8313 43.827 20.6639 45.8267 25.9965 45.9934C31.3291 46.16 35.9951 44.1603 39.6613 40.6608V36.6614C39.6613 33.3286 36.8283 30.4956 33.4955 30.4956Z",
    fill: "#D89F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.1a0ba3761858fcf9bdbae52fd126fe92.svg";
export { ForwardRef as ReactComponent };